import { use_slice_generation } from '@/hooks/store/use_slices';
import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useMemo } from 'react';

export function HOOK__image_aspect_ratio_for_generation_provider(field: FIELD__image_asset) {
  const { generation_current } = use_slice_generation(['generation_current']);

  const aspect_ratio = useMemo(() => get_aspect_ratio(), [generation_current, field]);

  function get_aspect_ratio() {
    let out = DTO__image_size.SQUARE_512.aspect_ratio;

    if (field.get_has_content()) {
      out = field.get_image_size().aspect_ratio;
    } else if (!generation_current.is_stub()) {
      out = generation_current.tool.graph.invocation_grid2d_view.grid2d_cell__aspect_ratio;
    }

    return out;
  }

  return aspect_ratio;
}
